import apiChange from '../apiChange';

import { ParamsBodyValidateChoose, ParamsDataValidateChoose } from 'utils/typeServices';

export const PostValidateChoose = async ({ body }: { body: ParamsBodyValidateChoose }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<ParamsDataValidateChoose>('/changeservice/validateChoose/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
